import { render } from "./order-details-component.vue?vue&type=template&id=25b02e21"
import script from "./order-details-component.vue?vue&type=script&lang=js"
export * from "./order-details-component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__